export const uk = {
    cancel: 'Отмена',
    save: 'Назначить',
    title: 'Доступ к пакету "{title}"'
};
